import React, { useState } from 'react';
import { Button } from 'components/Button/Button';
import { Text } from 'components/Typography';
import { AssessmentMenuOption } from 'containers/Tasks/components/AssessmentArea/AssessmentMenuOption/AssessmentMenuOption';
import TaskPreviewArea from 'containers/Tasks/components/TaskPreviewArea/TaskPreviewArea';
import style from './AssessmentResult.scss';

type Props = {
  details: {
    id?: string;
    name?: string;
    description?: string;
    result?: string;
  };
  onClose: () => void;
};

export const AssessmentResult: React.FC<Props> = ({ details, onClose }) => {
  const [isAssessmentResultVisible, setIsAssessmentResultVisible] = useState<boolean>(false);
  const { id = '', name = '', result = '' } = details;

  return (
    !!details && (
      <>
        <div className={style.container}>
          <Text variant="md" weight={600}>
            Results
          </Text>
          <AssessmentMenuOption option={{ id, name, description: result }} />
          <Button variant="outlined" onClick={() => setIsAssessmentResultVisible(true)}>
            View responses
          </Button>
        </div>
        {isAssessmentResultVisible && (
          <TaskPreviewArea previewResultId={id} onClose={onClose} onBack={() => setIsAssessmentResultVisible(false)} containerStyle={style.resultContainer} />
        )}
      </>
    )
  );
};
